import { useEffect, useState } from 'react'
import queryString from 'query-string'

import { API, Auth, Storage } from 'aws-amplify'
import { getFundraisingCampaign, getNylasEvent, listFundraisingCampaignDiscoveryCallsByFundraisingCampaign } from '../../managers/graphql/queries'
import { FundraisingCampaign, FundraisingCampaignDiscoveryCall, NylasEvent } from '../../API'
import { Button, CircularProgress, Dialog, TextField, Typography, FormControlLabel, Checkbox } from '@mui/material'
import MuiPhoneNumber from 'material-ui-phone-number'
import PhoneInput from 'react-phone-number-input/input'
import { E164Number, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'

import { atcb_init } from "add-to-calendar-button";
import 'add-to-calendar-button/assets/css/atcb.css';

import DownloadAppleAppStoreSVG from './../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'

import isEmail from 'validator/lib/isEmail'
import { toast } from 'react-toastify'

export default function DiscoveryCall(props: any) {

    const [discoveryCalls, setDiscoveryCalls] = useState<FundraisingCampaignDiscoveryCall[] | null>(null)
    const [selectedDiscoveryCall, setSelectedDiscoveryCall] = useState<FundraisingCampaignDiscoveryCall | null>(null)
    const [fundraisingCampaign, setFundraisingCampaign] = useState<FundraisingCampaign | null>(null)

    const [headerImageURI, setHeaderImageURI] = useState<string | null>(null)
    const [logoImageURI, setLogoImageURI] = useState<string | null>(null)

    const [showDiscoveryCallSignUpDialog, setShowDiscoveryCallSignUpDialog] = useState<boolean>(false)
    const [email, setEmail] = useState<string | null>(null)
    const [phoneNumber, setPhoneNumber] = useState<E164Number | undefined>(undefined)
    const [firstName, setFirstName] = useState<string | null>(null)
    const [lastName, setLastName] = useState<string | null>(null)
    const [sendTextMessageInvitation, setSendTextMessageInvitation] = useState<boolean>(true)

    const [loading, setLoading] = useState<boolean>(false)
    const [successfulRegistration, setSuccessfulRegistration] = useState<boolean>(false)
    const [ics, setIcs] = useState<string | null>(null)

    function handleClose() {
        setEmail(null)
        setPhoneNumber(undefined)
        setFirstName(null)
        setLastName(null)
        setShowDiscoveryCallSignUpDialog(false)
    }

    useEffect(() => {
        (async () => {
            var fundraisingCampaignID: string | null = null;
            if (queryString.parse(window.location.search).id) {
                const { data }: any = await API.graphql({
                    query: `
                    query ListFundraisingCampaignDiscoveryCallsByFundraisingCampaign(
                      $fundraisingCampaignID: ID
                      $sortDirection: ModelSortDirection
                      $filter: ModelFundraisingCampaignDiscoveryCallFilterInput
                      $limit: Int
                      $nextToken: String
                    ) {
                      listFundraisingCampaignDiscoveryCallsByFundraisingCampaign(
                        fundraisingCampaignID: $fundraisingCampaignID
                        sortDirection: $sortDirection
                        filter: $filter
                        limit: $limit
                        nextToken: $nextToken
                      ) {
                        items {
                          id
                          title
                          organizationID
                          fundraisingCampaignID
                          staffProfileID
                          startTimestamp
                          endTimestamp
                          latentHosted
                          invitationURL
                          nylasEventID
                          virtualMeetingURL
                          createdAt
                          updatedAt
                          staffProfile {
                            id
                            authAccountID
                            authAccount {
                              firstName
                              lastName
                            }
                            owner
                          }
                          organization {
                            id
                            name
                            shortName
                            description
                            locationID
                            website
                            phoneNumber
                            headerImageURI
                            ambassadorTermOverrideSingular
                            ambassadorTermOverridePlural
                            primaryColor
                            secondaryColor
                            createdAt
                            updatedAt
                            owner
                            location {
                              id
                              type
                              name
                              details
                              addressID
                              organizationID
                              createdAt
                              updatedAt
                              owner
                            }
                          }
                          fundraisingCampaign {
                            id
                            type
                            organizationID
                            staffLeadID
                            campaignName
                            introVideoURI
                            textMessageTemplate
                            initialMessageReminderTemplate
                            phoneCallScriptTemplate
                            followUpMessageTemplate
                            followUpYesMessageTemplate
                            followUpNoMessageTemplate
                            followUpReminderMessageTemplate
                            showVideo
                            showText
                            showCall
                            showFollowUp
                            active
                            publicVideoID
                            publicVideoProvider
                            campaignStartDate
                            campaignStartTime
                            campaignTimeZone
                            campaignEndDate
                            campaignEndTime
                            publicCampaignAbout
                            publicCampaignIntro
                            campaignGoal
                            perAmbassadorGoal
                            totalAmbassadorsGoal
                            perContactDonationGoal
                            progressChartType
                            ctaURL
                            pageLayout
                            primaryColor
                            secondaryColor
                            buttonBackgroundColor
                            buttonTextColor
                            customHeaderImageUploaded
                            customLogoImageUploaded
                            headerFont
                            bodyFont
                            ctaButtonText
                            givingCircleBaseAmount
                            givingCircleIncrements
                            givingCircleAllowCustomAmounts
                            ambassadorSpecificVideoUrlEnabled
                            ambassadorCanUploadVideoUrl
                            ambassadorSpecificCtaUrlEnabled
                            ambassadorCanUploadCtaUrl
                            crowbarVideoURL
                            recruitmentForCampaignID
                            classyCampaignID
                            classyAutogenerateAmbassadorTeams
                            classyDonationPageHostURL
                            useClassyCtaURL
                            useClassyFundraiserPage
                            personalFundraisingCampaignID
                            onDemandDiscoveryMeetingEnabled
                            onDemandDiscoveryMeetingURL
                            onDemandDiscoveryMeetingID
                            onDemandDiscoveryMeetingInvitationCode
                            createdAt
                            updatedAt
                            owner
                            onDemandDiscoveryMeeting {
                              id
                              title
                              organizationID
                              fundraisingCampaignID
                              staffProfileID
                              startTimestamp
                              endTimestamp
                              latentHosted
                              invitationURL
                              nylasEventID
                              virtualMeetingURL
                              createdAt
                              updatedAt
                              owner
                            }
                          }
                          owner
                        }
                        nextToken
                      }
                    }
                  `,
                    variables: {
                        fundraisingCampaignID: queryString.parse(window.location.search).id,
                        filter: {
                            startTimestamp: {
                                gt: new Date().toISOString()
                            }
                        }
                    },
                    authMode: 'AWS_IAM'
                })
                console.log(data)
                var _discoveryCalls: any[] = data.listFundraisingCampaignDiscoveryCallsByFundraisingCampaign.items
                _discoveryCalls.sort((a, b) => a.startTimestamp > b.startTimestamp ? 1 : -1)
                setDiscoveryCalls(_discoveryCalls)
                const getFundraisingCampaignResponse: any = await API.graphql({
                    query: `
                    query GetFundraisingCampaign($id: ID!) {
                        getFundraisingCampaign(id: $id) {
                          id
                          type
                          organizationID
                          staffLeadID
                          campaignName
                          introVideoURI
                          textMessageTemplate
                          phoneCallScriptTemplate
                          followUpMessageTemplate
                          followUpYesMessageTemplate
                          followUpNoMessageTemplate
                          showVideo
                          showText
                          showCall
                          showFollowUp
                          active
                          publicVideoID
                          publicVideoProvider
                          campaignEndDate
                          publicCampaignAbout
                          publicCampaignIntro
                          campaignGoal
                          perAmbassadorGoal
                          perContactDonationGoal
                          progressChartType
                          ctaURL
                          primaryColor
                          secondaryColor
                          buttonBackgroundColor
                          buttonTextColor
                          customHeaderImageUploaded
                          customLogoImageUploaded
                          headerFont
                          bodyFont
                          ctaButtonText
                          givingCircleBaseAmount
                          givingCircleIncrements
                          givingCircleAllowCustomAmounts
                          onDemandDiscoveryMeetingID
                          onDemandDiscoveryMeeting {
                            id
                            title
                            staffProfileID
                            staffProfile {
                                authAccount {
                                    firstName
                                    lastName
                                    primaryEmail
                                }
                            }
                            startTimestamp
                            endTimestamp
                            latentHosted
                            invitationURL
                            nylasEventID
                          }
                          createdAt
                          updatedAt
                          staffLead {
                            id
                            authAccountID
                            organizationID
                            role
                            name
                            nylasAccountID
                            nylasCalendarToken
                            nylasPrimaryCalendarID
                            createdAt
                            updatedAt
                            authAccount {
                              id
                              name
                              firstName
                              lastName
                            }
                          }
                          organization {
                            id
                            name
                            shortName
                            description
                            locationID
                            website
                            phoneNumber
                            headerImageURI
                            ambassadorTermOverrideSingular
                            ambassadorTermOverridePlural
                            primaryColor
                            secondaryColor
                            createdAt
                            updatedAt
                          }
                          owner
                        }
                      }
                    `,
                    variables: {
                        id: queryString.parse(window.location.search).id
                    },
                    authMode: 'AWS_IAM'
                })
                console.log(getFundraisingCampaignResponse)
                if (getFundraisingCampaignResponse.data && getFundraisingCampaignResponse.data.getFundraisingCampaign) {
                    const _fundraisingCampaign = getFundraisingCampaignResponse.data.getFundraisingCampaign

                    console.log(_fundraisingCampaign)

                    setFundraisingCampaign(_fundraisingCampaign)

                    if (_fundraisingCampaign.customHeaderImageUploaded) {
                        const uri = await Storage.get(`campaigns/${_fundraisingCampaign.id}/headerImage`, { level: 'public' })
                        setHeaderImageURI(uri)
                    } else {
                        const uri = await Storage.get(`organizations/${_fundraisingCampaign.organizationID}/headerImage`, { level: 'public' })
                        setHeaderImageURI(uri)
                    }
                    if (_fundraisingCampaign.customLogoImageUploaded) {
                        const uri = await Storage.get(`campaigns/${_fundraisingCampaign.id}/logoImage`, { level: 'public' })
                        setLogoImageURI(uri)
                    } else {
                        const uri = await Storage.get(`organizations/${_fundraisingCampaign.organizationID}/profilePicture`, { level: 'public' })
                        setLogoImageURI(uri)
                    }
                }

            }
        })()
    }, [])

    return (
        <div>
            <div className="container-fluid g-0">
                <div className="row g-0">
                    <div className="col-12 w-100 d-flex flex-column justify-content-center align-items-center">
                        <img
                            src={headerImageURI ? headerImageURI : ''}
                            style={{
                                objectFit: 'cover',
                                maxWidth: '100%',
                                width: '100%',
                                height: 500,
                                opacity: 0.4,
                            }}
                        />
                        <img
                            src={logoImageURI ? logoImageURI : ''}
                            style={{
                                objectFit: 'contain',
                                maxWidth: '80%',
                                width: '80%',
                                height: 200,
                                position: 'absolute'
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="container mb-5">
                {
                    !successfulRegistration ?
                        <div className="row">
                            <div className="col-12 mt-5 d-flex flex-column justify-content-center align-items-center">
                                <Typography variant="h3">{fundraisingCampaign && fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography>
                                <Typography variant="h1">{fundraisingCampaign && fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : ''}</Typography>
                            </div>
                            <div className="col-12 mt-5">
                                <Typography variant="h3">Select Discovery Meeting</Typography>
                                <Typography variant="body2">Below is a list of available Discovery Meetings. If you've been sent the link to this page, select one of the Discovery Meetings below to get some next steps on joining this team.</Typography>
                            </div>
                            {
                                discoveryCalls &&
                                discoveryCalls.map((discoveryCall) => {
                                    return (
                                        <div className="col-12 my-3">
                                            <div className="row mx-3 p-5 border rounded bg-light">
                                                <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start">
                                                    <Typography variant="h4">{new Date(discoveryCall.startTimestamp).toLocaleDateString()}</Typography>
                                                    <Typography variant="body1">{new Date(discoveryCall.startTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })} to {new Date(discoveryCall.endTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}</Typography>
                                                </div>
                                                <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-end">
                                                    <Button variant="contained" className="px-4" onClick={() => {
                                                        setShowDiscoveryCallSignUpDialog(true)
                                                        setSelectedDiscoveryCall(discoveryCall)
                                                    }}>Select Discovery Meeting</Button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                fundraisingCampaign && fundraisingCampaign.onDemandDiscoveryMeeting && fundraisingCampaign.onDemandDiscoveryMeeting != null && fundraisingCampaign.onDemandDiscoveryMeeting != undefined ?
                                    <div className="col-12 my-3">
                                        <div className="row mx-3 p-5 border rounded bg-light">
                                            <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start">
                                                <Typography variant="h4">Don't see a time that works?</Typography>
                                                <Typography variant="body1">View an on demand version of the meeting</Typography>
                                            </div>
                                            <div className="col-12 col-lg-6 d-flex flex-row justify-content-center justify-content-lg-end align-items-start">
                                                <Button variant="contained" className="px-4" onClick={() => {
                                                    setShowDiscoveryCallSignUpDialog(true)
                                                    setSelectedDiscoveryCall(fundraisingCampaign.onDemandDiscoveryMeeting!)
                                                }}>View On Demand Meeting</Button>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div />
                            }
                            <div className="col-12 d-flex flex-column justify-content-center align-items-center mt-5">
                                <Typography variant="h3">Download the Latent App</Typography>
                                <Typography variant="body2">Click below to download the Latent app and create your account before the Discovery Meeting starts.</Typography>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="p-5 d-flex flex-column justify-content-center align-items-center">
                                    <Typography variant="h3">Apple/iOS</Typography>
                                    <a href="https://apps.apple.com/us/app/latent/id1618551569" target="_blank"><img src={DownloadAppleAppStoreSVG} style={{ objectFit: 'contain', width: 200, height: 200 }} /></a>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="p-5 d-flex flex-column justify-content-center align-items-center">
                                    <Typography variant="h3">Google/Android</Typography>
                                    <a href='https://play.google.com/store/apps/details?id=com.flourish.latentmobile&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ objectFit: 'contain', width: 250, height: 200 }} /></a>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-12 mt-5 d-flex flex-column justify-content-center align-items-center">
                                <Typography variant="h1">{fundraisingCampaign && fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : ''}</Typography>
                                <Typography variant="h5">{fundraisingCampaign && fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography>
                            </div>
                            <div className="col-12 mt-5">
                                <Typography variant="h3">Registration Successful</Typography>
                                <Typography variant="body2">You've successfully registered for a Discovery Meeting! The next step is to download the Latent app. You'll need to download the app and create an account before the Discovery Meeting. Make sure to use the SAME email address and phone number you used to sign up for this Discovery Meeting to make sure your Discovery Meeting invitation gets linked to your account.</Typography>
                            </div>
                            {
                                ics &&
                                <div className="col-12">
                                    <div className="row mx-3 mt-5 p-5 border rounded bg-light">
                                        <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start my-3">
                                            <Typography variant="h3">Download Calendar Invitation</Typography>
                                        </div>
                                        <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start my-3">
                                            <Button variant="contained" className="w-100" onClick={() => {
                                                var pom = document.createElement('a');
                                                pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(ics.replace('METHOD:REQUEST', 'METHOD:PUBLISH')));
                                                pom.setAttribute('download', 'invitation.ics');

                                                if (document.createEvent) {
                                                    var event = document.createEvent('MouseEvents');
                                                    event.initEvent('click', true, true);
                                                    pom.dispatchEvent(event);
                                                }
                                                else {
                                                    pom.click();
                                                }
                                            }}>Download Invitation</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="col-12 col-lg-6">
                                <div className="p-5 d-flex flex-column justify-content-center align-items-center">
                                    <Typography variant="h3">Apple/iOS</Typography>
                                    <a href="https://apps.apple.com/us/app/latent/id1618551569" target="_blank"><img src={DownloadAppleAppStoreSVG} style={{ objectFit: 'contain', width: 200, height: 200 }} /></a>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="p-5 d-flex flex-column justify-content-center align-items-center">
                                    <Typography variant="h3">Google/Android</Typography>
                                    <a href='https://play.google.com/store/apps/details?id=com.flourish.latentmobile&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ objectFit: 'contain', width: 250, height: 200 }} /></a>
                                </div>
                            </div>
                        </div>
                }
            </div>

            <Dialog
                open={showDiscoveryCallSignUpDialog}
                onClose={() => handleClose()}
                maxWidth="md"
                fullWidth
            >
                {
                    fundraisingCampaign ?
                        <div className="p-5 row g-0">
                            <div className="col-12 d-flex flex-column justify-content-center-align-items-start mb-1">
                                <Typography variant="h2" className="mb-3">Register for Discovery Meeting</Typography>
                                <Typography variant="body1">Use the form below to register for this Discovery meeting for the {fundraisingCampaign && fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : 'Campaign'}. By registering, you're agreeing to receive communication via email and/or text message with a meeting invitation and follow-up steps to complete before the meeting. Text message and data rates may apply.</Typography>
                            </div>
                            <div className="col-12 d-flex flex-column justify-content-center-align-items-start mt-4 mb-5">
                                <Typography variant="body1">Selected time:</Typography>
                                {
                                    selectedDiscoveryCall && selectedDiscoveryCall.id != fundraisingCampaign?.onDemandDiscoveryMeetingID ?
                                        <Typography variant="h4">{new Date(selectedDiscoveryCall.startTimestamp).toLocaleDateString()} from {new Date(selectedDiscoveryCall.startTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} to {new Date(selectedDiscoveryCall.endTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Typography>
                                        : selectedDiscoveryCall && selectedDiscoveryCall.id == fundraisingCampaign?.onDemandDiscoveryMeetingID ?
                                            <Typography variant="h4">On Demand</Typography>
                                            : <div />
                                }
                            </div>
                            <div className="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-center justify-content-lg-start">
                                <TextField className="me-0 me-lg-3" fullWidth label="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
                            </div>
                            <div className="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-center justify-content-lg-end">
                                <PhoneInput defaultCountry="US" disableCountryCode={true} name="phoneNumber" type="tel" countryCodeEditable={false} onChange={(e) => { console.log(e); if (typeof e == 'string' && isValidPhoneNumber(e)) setPhoneNumber(parsePhoneNumber(e).number); else setPhoneNumber(undefined) }} variant="outlined" placeholder="Mobile Phone Number" required fullWidth label="Mobile Phone Number" autoComplete="tel-national"
                                    style={{ padding: '14px', width: '100%', borderRadius: '10px', borderWidth: '0.5px', fontFamily: 'Gilroy-Medium', borderColor: 'lightgray' }}
                                />
                            </div>
                            <div className="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-center justify-content-lg-start">
                                <TextField className="me-0 me-lg-3" fullWidth label="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} autoComplete="given-name" />
                            </div>
                            <div className="col-12 col-lg-6 d-flex flex-row justify-content-center justify-content-lg-end">
                                <TextField fullWidth label="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} autoComplete="family-name" />
                            </div>
                            {/* <div className="col-12">
                                <FormControlLabel disabled checked={true} control={<Checkbox checked={true} />} label="Send me an email invitation" />
                            </div>
                            <div className="col-12">
                                <FormControlLabel checked={sendTextMessageInvitation} onChange={(e, checked) => setSendTextMessageInvitation(checked)} control={<Checkbox />} label="Send me a text message invitation" />
                            </div> */}
                            <div className="col-12 mb-3 mt-1">
                                <Typography variant="caption">Standard messaging a data rates apply for text messages sent to the number you've indicated above. By clicking the "Register" button you are agreeing to receieve reminder text messages from Latent about this Discovery Meeting. You can opt out at any time.</Typography>
                            </div>
                            <div className="col-12 d-flex flex-row justify-content-center align-items-center mt-3">
                                <Button className="px-0 mx-3" variant="text" onClick={() => setShowDiscoveryCallSignUpDialog(false)}>close</Button>
                                {
                                    !loading ?
                                        <Button variant="contained" className="px-4 mx-3" onClick={async () => {
                                            if (firstName && lastName) {
                                                if (email) {
                                                    const _email = email.replace(/\s+/g, '')
                                                    if (isEmail(_email)) {
                                                        if (phoneNumber && isValidPhoneNumber(phoneNumber) && phoneNumber.length >= 10) {
                                                            setLoading(true)
                                                            if (selectedDiscoveryCall) {
                                                                const response = await API.post('RESTfundraising', '/fundraising/discovery-call/registration', {
                                                                    body: {
                                                                        firstName,
                                                                        lastName,
                                                                        email: _email.toLowerCase(),
                                                                        phoneNumber,
                                                                        discoveryCallID: selectedDiscoveryCall.id,
                                                                        sendSMSInvitation: sendTextMessageInvitation,
                                                                        recruitedByCampaignAmbassadorID: queryString.parse(window.location.search).ambassador ? queryString.parse(window.location.search).ambassador : null,
                                                                        fundraisingCampaignAmbassadorContactID: queryString.parse(window.location.search).contact ? queryString.parse(window.location.search).contact : null
                                                                    }
                                                                })
                                                                console.log(response)
                                                                if (response.status && response.status == 'success') {
                                                                    setSuccessfulRegistration(true)
                                                                    setShowDiscoveryCallSignUpDialog(false)
                                                                    if (response.payload && response.payload.ics) {
                                                                        setIcs(response.payload.ics)
                                                                    }
                                                                    toast.success('You successfully registered for the Discovery Meeting.', { containerId: 'main' })
                                                                } else {
                                                                    alert('There was an error registering. Please contact support or refresh the page and try again.')
                                                                }
                                                                setLoading(false)
                                                            } else {
                                                                alert("You haven't selected a Discovery Meeting.")
                                                            }
                                                            setLoading(false)
                                                        } else alert('Please enter a valid 10 digit phone number with an area code.')
                                                    }
                                                } else alert('Please enter a valid email address.')
                                            } else alert('You need to enter a first and last name to register.')
                                        }}>Register</Button>
                                        :
                                        <CircularProgress />
                                }
                            </div>
                        </div>
                        :
                        <div />
                }
            </Dialog>
        </div>
    )
}